import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import Stack from '@mui/material/Stack';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import SmallMuiXDatePicker from '../styled/small-mui-x-datepicker.component';

function getCurrentDate(){
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const currentDate = getCurrentDate(); // e.g., "2024-08-29"

export default function YearDatePicker({onYearChange}) {

    const [value, setValue] = useState(dayjs(currentDate));

    useEffect(()=>{
        if(onYearChange == null) return;
        onYearChange(value.$y);
    }, [value])

    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stack spacing={3}>
          <SmallMuiXDatePicker
            fontColor={'#5d5ed8'}
            views={['year']}
            label="Year"
            value={value}
            onChange={(newValue) => {
              setValue(newValue);
            }}
            renderInput={(params) => <TextField {...params} helperText={null} />}
          />
        </Stack>
      </LocalizationProvider>
    );
}